import { render, staticRenderFns } from "./notPermission.vue?vue&type=template&id=60884882&scoped=true&"
import script from "./notPermission.vue?vue&type=script&lang=js&"
export * from "./notPermission.vue?vue&type=script&lang=js&"
import style0 from "./notPermission.vue?vue&type=style&index=0&id=60884882&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60884882",
  null
  
)

export default component.exports